// A link inside running text, whatever element carries it: the colour, the underline and the weight
// are tokens each brand sets (D1345). `ProseLink`, `Anchor tone="link"` and `Button variant="text-link"`
// all read this one line, so no site draws its own.
export const LINK_LOOK =
  "text-link underline underline-offset-(--link-offset) font-(weight:--link-weight) transition-colors hover:text-link-hover";
